export const PASSWORD = 'PASSWORD';
export const PASSWORD_VERIFIED = `${PASSWORD}_VERIFIED`;
export const PASSWORD_INCORRECT = `${PASSWORD}_INCORRECT`;
export const PASSWORD_UPDATE = `${PASSWORD}_UPDATE`;
